// On click scroll
  function scrollDown(e){
    const targetTitle = e.getAttribute("title");
      const targetBlock = document.getElementById(targetTitle);
      if (targetBlock) {
        targetBlock.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
  }